import {NotificationCustomActionType, NotificationDto} from '@lib/infrastructure';
import {Notification} from '../entities';
import {TranslationService} from '../../@types/i18next';
import {CustomActionCategory} from './types';

export const filterUnreadNotifications = (notifications: Notification[]) =>
  notifications.filter((notif) => !notif.isRead);

export const notificationDtoToNotification = (notificationDto: NotificationDto): Notification => {
  return {
    ...notificationDto,
    isDeleting: false,
  };
};

export const notificationToNotificationDto = (notification: Notification): NotificationDto => {
  return {
    ...notification,
  };
};

export const getCustomActionCategories = (
  t: TranslationService,
): {[key in NotificationCustomActionType]: CustomActionCategory | undefined} => {
  return {
    NoShow: {
      id: 'NoShow',
      actions: [
        {id: 'NoShow__CancelRoomRemoval', title: t('notifications:Actions.CancelRoomRemoval')},
        {id: 'NoShow__ApproveRoomRemoval', title: t('notifications:Actions.ApproveRoomRemoval'), destructive: true},
      ],
    },
  };
};
